<template>
  <paper-simple class="d-md-flex mt-2">
    <sidebar
      :tab="activeTab"
      @activeTab="changeActiveTab"
    />
    <div
      :key="layout"
      class="w-100 mt-2"
    >
      <component :is="layout" />
    </div>
  </paper-simple>
</template>
<script>
import Sidebar from './parts/Sidebar.vue'

const Origins = () => import('./parts/Origins.vue')
const OriginGroups = () => import('./parts/OriginGroups.vue')
const Healthchecks = () => import('./parts/Healthchecks.vue')

export default {
  name: 'OriginDetails',
  components: {
    Sidebar,
    Origins,
    OriginGroups,
    Healthchecks,
  },
  data() {
    return {
      activeTab: 0,
    }
  },
  computed: {
    layout() {
      if (this.activeTab === 1) {
        return 'origin-groups'
      }
      if (this.activeTab === 2) {
        return 'healthchecks'
      }
      return 'origins'
    },
  },
  created() {
    if (this.$route.params.activeTab) {
      this.activeTab = this.$route.params.activeTab
    }
  },
  methods: {
    changeActiveTab(val) {
      this.activeTab = val
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .empty-loading-table {
    min-height: 80px;
  }
}
</style>
